export const TARGETS = {
    BLANK: '_blank',
    SELF: '_self',
}
